module.exports = __webpack_public_path__ + "img/testIcon.9bee80ad.svg";